import React from 'react'
import Widget from "./Widget"

const Widgets = ({widgets}) => {
    let x = 0
    let y = 25

    return (
        <div className="widgets-holder">
            {
                widgets.map( ({image, imageWidth, imageHeight, title, description}, index) => <Widget
                    key={index}
                    image={image}
                    imageWidth={imageWidth}
                    imageHeight={imageHeight}
                    title={title}
                    description={description}
                    parallaxData={{
                        "data-bottom-top":"transform:translatey(200px); opacity: 0;",
                        [`data--${x+=25}-bottom`]:"opacity: 0;",
                        [`data--${y+=25}-bottom`]:"transform:translatey(0px); opacity: 1;",
                    }}
                />)
            }
        </div>
    )
}

export default Widgets



// WEBPACK FOOTER //
// ./src/components/Widgets.js